import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import cx from 'classnames'
import css from './appointment-type-modal.css'
import ModalContent from './ModalContent'
import ModalActions from './ModalActions'

class BlastMessageFiltersModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tempSelectedAppointmentTypeIds: [],
      tempSelectedPatientStatusIds: [],
      page: 0,
      searchTerm: '',
    }
  }

  componentDidMount() {
    const {
      hasTimeRange,
      selectedAppointmentTypeIds,
      selectedPatientStatusIds,
    } = this.props
    if (!hasTimeRange) {
      this.setInitialState({
        tempSelectedAppointmentTypeIds: [],
        tempSelectedPatientStatusIds: selectedPatientStatusIds,
        page: 1,
      })
    } else {
      this.setInitialState({
        tempSelectedAppointmentTypeIds: selectedAppointmentTypeIds,
        tempSelectedPatientStatusIds: selectedPatientStatusIds,
        page: 0,
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      selectedAppointmentTypeIds,
      selectedPatientStatusIds,
      hasTimeRange,
    } = this.props
    const tempState = {}
    if (nextProps.selectedAppointmentTypeIds !== selectedAppointmentTypeIds) {
      tempState.tempSelectedAppointmentTypeIds =
        nextProps.selectedAppointmentTypeIds
    }
    if (nextProps.selectedPatientStatusIds !== selectedPatientStatusIds) {
      tempState.tempSelectedPatientStatusIds =
        nextProps.selectedPatientStatusIds
    }
    if (nextProps.hasTimeRange !== hasTimeRange) {
      tempState.page = nextProps.hasTimeRange ? 0 : 1
    }
    if (Object.keys(tempState).length) {
      this.setState({
        ...tempState,
      })
    }
  }

  setInitialState = ({
    tempSelectedAppointmentTypeIds,
    tempSelectedPatientStatusIds,
    page,
  }) => {
    this.setState({
      tempSelectedAppointmentTypeIds,
      tempSelectedPatientStatusIds,
      page,
    })
  }

  handleSearch = (e) => {
    this.setState({ searchTerm: e.target.value })
  }

  render() {
    const {
      appointmentTypes,
      open,
      hasTimeRange,
      patientStatuses,
      selectATypesAndPStatuses,
      toggleFilterModal,
      pmsType,
    } = this.props

    const {
      page,
      searchTerm,
      tempSelectedAppointmentTypeIds,
      tempSelectedPatientStatusIds,
    } = this.state

    const isTops = process.env.REACT_APP_IS_TOPS
    const isOrthoTrac = pmsType === 'OrthoTrac'

    const handleRemoveType = (item, type) => {
      const filteredTypes = this.state[type].filter(
        chipType => chipType !== item,
      )
      this.setState({ [type]: [...filteredTypes] })
    }

    const handleAddType = (item, type) => {
      if (type.includes(item)) return
      this.setState({ [type]: [...this.state[type], item] })
    }

    const handleAddAllOfType = (type) => {
      const typesToAdd =
        type === 'tempSelectedAppointmentTypeIds'
          ? appointmentTypes
          : patientStatuses
      this.setState({
        [type]: typesToAdd.map(currType => currType.id),
      })
    }

    const handleClearAllOfType = type =>
      this.setState({
        [type]: [],
      })

    const setCurrentPage = () => {
      if (!hasTimeRange) {
        this.setState({
          page: 1,
        })
      } else {
        this.setState({
          page: 0,
        })
      }
    }

    const handleClearLocalFilter = () =>
      this.setState({
        tempSelectedAppointmentTypeIds: this.props.selectedAppointmentTypeIds,
        tempSelectedPatientStatusIds: this.props.selectedPatientStatusIds,
        page: 0,
      })

    const closeModal = () => {
      handleClearLocalFilter()
      toggleFilterModal()
      setCurrentPage()
    }

    const submitModal = () => {
      selectATypesAndPStatuses(
        tempSelectedAppointmentTypeIds,
        tempSelectedPatientStatusIds,
      )
      setCurrentPage()
      toggleFilterModal()
    }

    const handleSwitchPage = (direction) => {
      if (direction === 'back') {
        this.setState({
          page: page - 1,
          searchTerm: '',
        })
      } else {
        this.setState({
          page: page + 1,
          searchTerm: '',
        })
      }
    }

    const containerClasses = cx(css.appointmentTypeModal, {
      [css.appointmentTypeModalShowing]: open,
    })
    const contentContainerClasses = cx(css.appointmentTypeModalContainer, {
      [css.appointmentTypeModalContainerShowing]: open,
    })

    return (
      <div className={containerClasses}>
        <div
          className={css.appointmentTypeModalOverlay}
          onClick={toggleFilterModal}
          tabIndex="0"
          role="button"
          aria-pressed="false"
        />
        <div className={contentContainerClasses}>
          <div>
            <span className={css.appointmentTypeModalTitle}>
              {`Filter By ${
                page === 0 ? 'Appointment Types' : 'Patient Statuses'
              }`}
            </span>
            <span>{`If nothing is selected then all ${
              page === 0 ? 'appointment types' : 'patient statuses'
            } will be selected`}</span>
          </div>
          <ModalContent
            appointmentTypes={appointmentTypes}
            handleAddAllOfType={handleAddAllOfType}
            handleAddType={handleAddType}
            handleClearAllOfType={handleClearAllOfType}
            handleRemoveType={handleRemoveType}
            handleSearch={this.handleSearch}
            page={page}
            patientStatuses={patientStatuses}
            searchTerm={searchTerm}
            selectedAppointmentTypeIds={tempSelectedAppointmentTypeIds}
            selectedPatientStatusIds={tempSelectedPatientStatusIds}
          />
          <ModalActions
            closeModal={closeModal}
            handleSwitchPage={handleSwitchPage}
            hasTimeRange={hasTimeRange}
            isTops={isTops}
            isOrthoTrac={isOrthoTrac}
            selectedApptTypes={tempSelectedAppointmentTypeIds}
            selectedPatientStatuses={tempSelectedPatientStatusIds}
            submitModal={submitModal}
            page={page}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({
  account: {
    auth: { pmsType },
  },
  appointmentTypes: { appointmentTypes },
}) => ({
  appointmentTypes,
  pmsType,
})

BlastMessageFiltersModal.propTypes = {
  appointmentTypes: PropTypes.arrayOf(PropTypes.object),
  hasTimeRange: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  patientStatuses: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectATypesAndPStatuses: PropTypes.func.isRequired,
  selectedAppointmentTypeIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedPatientStatusIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  toggleFilterModal: PropTypes.func.isRequired,
  pmsType: PropTypes.string,
}

export default connect(mapStateToProps)(BlastMessageFiltersModal)



// WEBPACK FOOTER //
// ./src/components/PatientGroups/PatientList/BlastMessageFiltersModal/index.js